import { render, staticRenderFns } from "./platformParaTable.vue?vue&type=template&id=54346438&scoped=true&"
import script from "./platformParaTable.vue?vue&type=script&lang=js&"
export * from "./platformParaTable.vue?vue&type=script&lang=js&"
import style0 from "./platformParaTable.vue?vue&type=style&index=0&id=54346438&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54346438",
  null
  
)

export default component.exports